import React from 'react';
import sanitizeFilename from '../../helpers/sanitize-filename';
import Multilingual from './Multilingual';
import TextInput from './TextInput';
import CheckBox from './CheckBox';
import DropdownSelector from './DropdownSelector';

const MultilingualTextInput = Multilingual(TextInput);

export default class PictureInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelectFile = this.handleSelectFile.bind(this);
    this._hasChoosedFile = false;
  }
  render() {
    const mode = this.props.mode || 'full';
    return (
      <fieldset>
        <legend>{this.props.title} { '(< 5Mo)' }</legend>
          <div className="form-group">
            <label>
              FILE { this.displayFilename(this.props.picture.filename) }
            </label>
            <div>
              <input type="file" name="file" onChange={ this.handleSelectFile } />
            </div>
          </div>
          {
            this._hasChoosedFile
              ? <TextInput
                  label="Filename"
                  name="filename"
                  value={ this.displayFilename(this.props.picture.filename) }
                  onChange={ this.handleChange.bind(this, 'filename') }
                />
              : null
          }
          {
            mode === 'full'
              ? <div>
                  <CheckBox
                    label="Published"
                    name="published"
                    checked={ this.props.picture.published }
                    onChange={ this.handleClickCheckbox.bind(this, 'published') }
                  />
                  <CheckBox
                    label="Shared"
                    name="shared"
                    checked={ this.props.picture.shared }
                    onChange={ this.handleClickCheckbox.bind(this, 'shared') }
                  />
                  <DropdownSelector
                    label="Type"
                    name="type"
                    value={ this.props.picture.type }
                    options={ this.typeOptions() }
                    onChange={ this.handleChange.bind(this, 'type') }
                  />
                </div>
              : null
          }
          <MultilingualTextInput
            label="Title"
            name="title"
            value={ (this.props.picture.title || {}).$i18n }
            onChange={ this.handleChangeLocalized.bind(this, 'title') }
            availableLocales={ this.props.availableLocales }
          />
          <MultilingualTextInput
            label="Description"
            name="description"
            value={ (this.props.picture.description || {}).$i18n }
            onChange={ this.handleChangeLocalized.bind(this, 'description') }
            availableLocales={ this.props.availableLocales }
          />
          {
            this.props.picturesList
              ? <DropdownSelector
                  label="Position"
                  name="_new_position"
                  placeholder="First"
                  value={ this.props.picture._new_position }
                  options={ this.picturesListOptions(this.props.defaultLanguage) }
                  onChange={ this.handleChange.bind(this, '_new_position') }
                />
              : null
          }
      </fieldset>
    );
  }
  displayFilename(filename) {
    if (!filename) return '';
    return filename[this.props.defaultLanguage];
  }

  handleSelectFile(evt) {
    const htmlFile = evt.currentTarget.files[0];
    if (!['image/jpeg', 'image/png', 'image/gif'].includes(htmlFile.type)) return null;
    if (htmlFile.size > 5000000) return null;
    const picture = { ...this.props.picture };
    picture.filename = picture.filename || {};
    picture.filename[this.props.defaultLanguage] = sanitizeFilename(htmlFile.name);
    if (!picture.id) picture._new = true;
    picture.image_file = htmlFile;
    this.props.onChange(picture);
    this._hasChoosedFile = true;
  }
  handleChange(attributeName, field) { // TODO
    const { name, value } = field;
    const picture = { ...this.props.picture };
    if (attributeName === 'filename') {
      picture[attributeName] = picture[attributeName] || {};
      picture[attributeName][this.props.defaultLanguage] = sanitizeFilename(value);
    } else {
      picture[attributeName] = value;
    }
    this.props.onChange(picture);
  }
  handleChangeLocalized(attributeName, field) {
    const { name, value } = field;
    this.handleChange(attributeName, { value: { $i18n: value } });
  }
  handleClickCheckbox(attributeName) {
    const picture = { ...this.props.picture };
    picture[attributeName] = !picture[attributeName];
    this.props.onChange(picture);
  }
  typeOptions() {
    return [
      { name: 'interior', value: 'interior' },
      { name: 'exterior', value: 'exterior' },
      { name: 'surroundings', value: 'surroundings' },
      { name: 'property_plan', value: 'property_plan' },
      { name: 'other', value: 'other' },
    ];
  }
  picturesListOptions(defaultLanguage) {
    return (this.props.picturesList || []).map((picture, i) => {
      const filename = picture.filename ? (picture.filename.$i18n || {})[defaultLanguage] : '';
      return { name: `After ${filename}`, value: i + 1 };
    });
  }
}



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/PictureInput.jsx